import { INIT_PAGE_STATE } from "../../constant/constant";
import {
  START_SYNC,
  START_SYNC_ERROR,
  START_SYNC_SUCCESS,
  PROGRESS_SYNC,
  PROGRESS_SYNC_ERROR,
  PROGRESS_SYNC_SUCCESS
} from "./actions";

const INIT_STATE = {
  startSync: {
    data: null,
    loading: false,
    error: false,
    message: null,
  },
  syncProcess: {
    data: null,
    loading: false,
    error: false,
    message: null,
  },
};


const syncReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case START_SYNC:
      return {
        ...state,
        startSync: {
          ...state.startSync,
          data: action.payload.item,
          loading: true,
          error: false,
          message: null,
        },
      };
    case START_SYNC_SUCCESS:
      return {
        ...state,
        startSync: {
          ...state.startSync,
          data: null,
          loading: false,
          error: false,
        },
      };

    case START_SYNC_ERROR:
      return {
        ...state,
        startSync: {
          ...state.startSync,
          loading: false,
          error: true,
          message: action.payload.toString(),
        },
      };

    case PROGRESS_SYNC:
      return {
        ...state,
        syncProcess: {
          data: !action.payload.loading ? state.syncProcess.data : null,
          loading: action.payload.loading,
          error: false,
          message: null,
        },
      };

    case PROGRESS_SYNC_SUCCESS: {
      return {
        ...state,
        syncProcess: {
          ...state.syncProcess,
          data: action.payload,
          loading: false,
          error: false,
          message: null,
        },
      };
    }
    case PROGRESS_SYNC_ERROR:
      return {
        ...state,
        syncProcess: {
          ...state.syncProcess,
          data: null,
          loading: false,
          error: true,
          message: action.payload,
        },
      };
    
    default:
      return state;
  }
};

export default syncReducer;